import { CUSTOM_FIELD_TYPES } from '@constants/app.constants';
import { CustomFieldModel } from '@models/custom-field.model';

// Depth-first search of a question's own customFieldDependencies chain (recursive — a
// dependency can itself have further dependencies, matching however deep the recursive
// rendering template nests). Returns the worker-select question with the given id, or — when no
// id is given — the first worker-select question found. The id matters when a host renders more
// than one worker question: without it the first match is cleared, which need not be the one
// whose answer actually went stale.
export function findWorkerSelectQuestion(question: CustomFieldModel, questionId?: number): CustomFieldModel | null {
  if (question?.type === CUSTOM_FIELD_TYPES.CUSTOM_FIELD_WORKER_SELECT
    && (questionId === undefined || question.id === questionId)) {
    return question;
  }
  if (question?.customFieldDependencies?.length > 0) {
    for (const dependency of question.customFieldDependencies) {
      const found = findWorkerSelectQuestion(dependency, questionId);
      if (found) {
        return found;
      }
    }
  }
  return null;
}

// Clears a stale worker-select answer wherever it sits in a set of top-level questions (each
// searched through its full dependency chain). Shared by every host that renders booking
// questions, so a store choice that invalidates the advisor answer visibly empties that
// question instead of leaving a stale name on screen after the answer was already dropped
// from the submitted values. Returns the index of the top-level question whose chain held the
// worker question, or -1 when this host renders no worker-select at all.
export function clearWorkerSelectAnswer(questions: CustomFieldModel[], questionId?: number): number {
  for (let index = 0; index < (questions?.length ?? 0); index++) {
    const workerQuestion = findWorkerSelectQuestion(questions[index], questionId);
    if (!workerQuestion) {
      continue;
    }
    if (workerQuestion.customerSelectedValue) {
      workerQuestion.customerSelectedValue = [];
    }
    return index;
  }
  return -1;
}
